import React, { lazy, Suspense } from 'react';
import {
    EDIT_USER_DRAWER,
    ADD_USER_DRAWER,
    EDIT_PRODUCT_DRAWER,
    EDIT_GUEST_USER_DRAWER,
} from 'src/features/users/constants/drawerConstants';
import LoadingDialog from 'src/components/LoadingDialog';
import IMPORTED_USERS from 'src/features/users/components/ImportedUsers/Constants';
import { ADD_ROLE_DRAWER, CLONE_ROLE_DRAWER, EDIT_ROLE_DRAWER } from 'src/features/identity-roles/constants';
import { CLONE_APP_ROLE_DRAWER, EDIT_APP_ROLE_DRAWER } from 'src/features/application-roles/constants';
import { CwLog } from 'cw-ui-core';
import { ADD_IDENTITY_ROLE_DRAWER } from 'src/features/identity-roles-v2/constants';
import { NOTIFICATIONS_DRAWER } from 'src/features/notifications/constants';
import AsioNeonResponsiveThemeProvider from 'src/theme/AsioNeonResponsiveThemeProvider';

// Lazy load the drawer components
const EditUserDrawerContainer = lazy(() => import('src/features/users/components/EditUser/EditUserDrawerContainer'));
const AddUserDrawerContainer = lazy(() => import('src/features/users/components/AddUser/AddUserDrawerContainer'));
const ImportedUsersContainer = lazy(
    () => import('src/features/users/components/ImportedUsers/ImportedUsers/ImportedUsersContainer')
);
const EditProductDrawerContainer = lazy(
    () => import('src/features/products/components/EditProductDrawer/EditProductDrawerContainer')
);
const AddRoleDrawerContainer = lazy(
    () => import('src/features/identity-roles/components/AddRole/AddRoleDrawerContainer')
);
const NewEditRoleDrawerContainer = lazy(
    () => import('src/features/identity-roles/components/EditRole/NewEditRoleDrawerContainer')
);
const CloneRoleDrawerContainer = lazy(
    () => import('src/features/identity-roles-v2/components/CloneRoleDrawer/CloneRoleDrawerContainer')
);
const CloneAppRoleDrawerContainer = lazy(
    () => import('src/features/application-roles/components/CloneAppRoleDrawer/CloneAppRoleDrawerContainer')
);
const EditAppRoleDrawerContainer = lazy(
    () => import('src/features/application-roles/components/EditAppRoleDrawer/EditAppRoleDrawerContainer')
);
const AddIdentityRoleDrawerContainer = lazy(
    () => import('src/features/identity-roles-v2/components/AddIdentityRoleDrawer/AddIdentityRoleDrawerContainer')
);
const NotificationDrawerContainer = lazy(
    () => import('src/features/notifications/components/NotificationDrawerContainer')
);
const EditGuestUserDrawerContainer = lazy(
    () => import('src/features/guest-users/components/EditGuestUserDrawer/EditGuestUserDrawerContainer')
);

const getDrawer = drawerId => {
    switch (drawerId) {
        case ADD_USER_DRAWER:
            return <AddUserDrawerContainer key={drawerId} />;
        case EDIT_USER_DRAWER:
            return <EditUserDrawerContainer key={drawerId} />;
        case IMPORTED_USERS:
            return <ImportedUsersContainer key={drawerId} />;
        case EDIT_PRODUCT_DRAWER:
            return <EditProductDrawerContainer key={drawerId} />;
        case ADD_ROLE_DRAWER:
            return <AddRoleDrawerContainer key={drawerId} />;
        case EDIT_ROLE_DRAWER:
            return <NewEditRoleDrawerContainer key={drawerId} />;
        case CLONE_ROLE_DRAWER:
            return <CloneRoleDrawerContainer key={drawerId} />;
        case CLONE_APP_ROLE_DRAWER:
            return <CloneAppRoleDrawerContainer key={drawerId} />;
        case EDIT_APP_ROLE_DRAWER:
            return <EditAppRoleDrawerContainer key={drawerId} />;
        case ADD_IDENTITY_ROLE_DRAWER:
            return <AddIdentityRoleDrawerContainer key={drawerId} />;
        case NOTIFICATIONS_DRAWER:
            return <NotificationDrawerContainer key={drawerId} />;
        case EDIT_GUEST_USER_DRAWER:
            return <EditGuestUserDrawerContainer key={drawerId} />;
        default:
            CwLog.error(`getDrawerContent fn -> Unknown drawer: ${drawerId}`);
            return null;
    }
};

const getDrawerFactory = drawerId => {
    if (!drawerId) {
        return null;
    }
    return (
        <AsioNeonResponsiveThemeProvider>
            <Suspense fallback={<LoadingDialog />}>{getDrawer(drawerId)}</Suspense>
        </AsioNeonResponsiveThemeProvider>
    );
};

export default getDrawerFactory;
